// src/pages/JoinGwin.jsx
import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../../supabaseClient";
import { getHasBusinessForUser } from "../../hooks/useBusinessGate";

export default function JoinGwin() {
  const navigate = useNavigate();

  const params = useMemo(() => {
    return new URLSearchParams(window.location.search);
  }, []);

  const tokenHash = params.get("token_hash") || "";
  const type = params.get("type") || "signup";

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  async function handleJoinGwin() {
    setErrorMessage("");

    if (!tokenHash) {
      setErrorMessage("This confirmation link is missing its verification token. Please request a new email.");
      return;
    }

    if (type !== "signup") {
      setErrorMessage("This confirmation link is not valid. Please request a new email.");
      return;
    }

    setLoading(true);

    try {
      const { error } = await supabase.auth.verifyOtp({
        token_hash: tokenHash,
        type: "signup",
      });

      if (error) {
        console.error("Signup confirmation error:", error);
        setErrorMessage("This confirmation link is invalid or expired. Please request a new email.");
        return;
      }

      const {
        data: { user },
      } = await supabase.auth.getUser();

      const hasBiz = user?.id ? await getHasBusinessForUser(user.id) : false;

      navigate(hasBiz ? "/dashboard" : "/profile-gate", {
        replace: true,
      });
    } catch (err) {
      console.error("Unexpected signup confirmation error:", err);
      setErrorMessage("Something went wrong while confirming your account. Please try again.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen bg-[#FFF7ED] flex items-center justify-center px-4 font-sans">
      <div className="w-full max-w-md rounded-3xl bg-white p-6 text-center shadow-xl border border-orange-100">
        <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-orange-100 text-3xl">
          🚀
        </div>

        <h1 className="text-2xl font-extrabold text-gray-900 mb-2">
          Join Gwin
        </h1>

        <p className="text-gray-600 leading-relaxed mb-6">
          Confirm your account and continue to your Gwin setup steps.
        </p>

        {errorMessage && (
          <div className="mb-4 rounded-2xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
            {errorMessage}
          </div>
        )}

        <button
          type="button"
          onClick={handleJoinGwin}
          disabled={loading}
          className="w-full rounded-2xl bg-[#FF914D] px-4 py-3 font-bold text-white shadow-md disabled:opacity-60"
        >
          {loading ? "Joining Gwin..." : "Join Gwin"}
        </button>

        <p className="mt-5 text-xs text-gray-500">
          Only click the newest confirmation email. Old links may no longer work.
        </p>
      </div>
    </div>
  );
}